import React from 'react';
import { Listbox } from '@zillow/constellation';

import type { Lease, Section } from '../../../../models/index';
import { LEASE_TERMS } from '../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  lease: Lease;
};

export default function LeaseTermsListBox({ section, setSectionValues }: Props): JSX.Element {
  function onOptionChange(value: string): void {
    setSectionValues({
      [LEASE_TERMS.FIELD_NAME.IS_FIXED]: value === LEASE_TERMS.FIELD_NAME.IS_FIXED,
      [LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH]: value === LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH,
    });
  }

  return (
    <Listbox
      value={
        section.getFieldValue(LEASE_TERMS.FIELD_NAME.IS_FIXED)
          ? LEASE_TERMS.FIELD_NAME.IS_FIXED
          : section.getFieldValue(LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH)
            ? LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH
            : ''
      }
      onChange={onOptionChange}
      appearance="radio"
      options={[
        {
          value: LEASE_TERMS.FIELD_NAME.IS_FIXED,
          label: LEASE_TERMS.LABEL.FIXED_HEADER,
          meta: LEASE_TERMS.LABEL.FIXED_CONTENT,
          disabled: section.isFieldDisabled(LEASE_TERMS.FIELD_NAME.IS_FIXED),
        },
        {
          value: LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH,
          label: LEASE_TERMS.LABEL.MONTH_TO_MONTH_HEADER,
          meta: LEASE_TERMS.LABEL.MONTH_TO_MONTH_CONTENT,
          disabled: section.isFieldDisabled(LEASE_TERMS.FIELD_NAME.IS_MONTH_TO_MONTH),
        },
      ]}
    />
  );
}
